import styled from 'styled-components';

const InfoTooltipStyled = styled.div(({ theme }) => ({
  padding: theme.space[2],
  textAlign: 'left',
}));

export { InfoTooltipStyled };
